import Vue from "vue";
import Vuex from "vuex";

import {
  db,
  imagesRef
} from '../plugins/firebase';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    restaurantUrlId: "",
    restaurantInfo: {},
    menuList: [],
    logoUrl: "",
    menuCatWrapper: [],
    catItemsWrapper: [],
    toggleMenu: true,
    toggleCat: false,
    toggleItems: false,
    currentMenu: {},
    currentCat: {},
    loader: true
  },
  mutations: {
    setLoader(state){
      state.loader = !state.loader;
    },
    setRestaurant(state, payload) {
      state.restaurantInfo = payload;
    },
    setRestaurantId(state, payload) {
      state.restaurantInfo.restaurantId = payload;
    },
    setMenu(state, payload) {
      if (localStorage.getItem('menuList')) {
        state.menuList = payload;
      } else {
        state.menuList.push(payload);
      }
      state.currentMenu = payload[0];
    },
    setMenuId(state, payload) {
      state.menuList[payload.index].menuId = payload.id;
    },
    setLogoUrl(state, payload) {
      state.logoUrl = payload;
    },
    setCategories(state, payload) {
      if (payload.completeCat) {
        state.menuCatWrapper = payload.cat;
      } else {
        state.menuCatWrapper.push(payload.cat);
      }

    },
    setItems(state, payload) {
      if (payload.completeItem) {
        state.catItemsWrapper = payload.item;
      } else {
        state.catItemsWrapper.push(payload.item);
      }
    },
    setToggleMenu(state) {
      state.toggleMenu = !state.toggleMenu;
    },
    setToggleCat(state) {
      state.toggleCat = !state.toggleCat;
    },
    setToggleItems(state) {
      state.toggleItems = !state.toggleItems;
    },
    setCurrentMenu(state, payload) {
      state.currentMenu = payload;
    },
    setCurrentCat(state, payload) {
      state.currentCat = payload;
    },
    setRestaurantUrlId(state, payload) {
      state.restaurantUrlId = payload;
    },
    resetAllStates(state) {
      state.restaurantInfo= {};
      state.menuList= [];
      state.logoUrl= "";
      state.menuCatWrapper= [];
      state.catItemsWrapper= [];
      state.toggleMenu= true;
      state.toggleCat= false;
      state.toggleItems= false;
      state.currentMenu= {};
      state.currentCat= {};
    },
  },
  actions: {
    getUrlParam({dispatch},{parameter, defaultvalue}){
        var urlparameter = defaultvalue;
        if(window.location.href.indexOf(parameter) > -1){
          urlparameter = dispatch('getUrlVars', {param: parameter});
        }
        return urlparameter;
    },
    getUrlVars({commit},{param}) {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,parameter,value) {
          if("restaurantId" === parameter) {
            vars[parameter] = value;
            commit('setRestaurantUrlId', value);
          }
      });

      return vars;

    },
    readRestaurant({state,commit,dispatch}) {
      db.collection('restaurants').doc(state.restaurantUrlId)
        .get()
        .then((doc) => {
          commit('setRestaurant', doc.data());
          commit('setRestaurantId', doc.id);
          dispatch('readMenus');
          dispatch('getImgUrl');
          let parsed = JSON.stringify(state.restaurantInfo);
          localStorage.setItem('restaurantInfo', parsed);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    readMenus({state,commit}) {
      var that = this;
      db.collection('menus').where("restaurants", "array-contains", state.restaurantUrlId)
        .orderBy("order", "asc")
        .get()
        .then(function(querySnapshot) {
          let i = 0;
          querySnapshot.forEach(function(doc) {
            commit('setMenu', doc.data());
            commit('setMenuId', {
              index: i,
              id: doc.id
            });
            i++;
          });
          let parsed = JSON.stringify(state.menuList);
          localStorage.setItem('menuList', parsed);
          // that.readCategories();
          that.dispatch('readCategories');
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    getImgUrl({state,commit}) {
      imagesRef.child(state.restaurantInfo.restaurantId).child(state.restaurantInfo.logoImg).getDownloadURL().then(function(url) {
        commit('setLogoUrl', url);
        localStorage.logoUrl = state.logoUrl;
      }).catch(function(error) {
        console.log("error! " + error);
      });
    },
    async readCategories({state}) {
      let currentMenu;
      var that = this;
      for (let y = 0; y < state.menuList.length; y++) {
        currentMenu = state.menuList[y];
        await db.collection('menus').doc(state.menuList[y].menuId).collection('categories')
          .orderBy("order", "asc").orderBy("title")
          .get()
          .then(function(querySnapshot) {
            that.dispatch('setCategoriesJSON', {
              response: querySnapshot,
              menu: currentMenu
            });
            var parsed = JSON.stringify(state.menuCatWrapper);
            localStorage.setItem('menuCat', parsed);
          });
      }


    },
    setCategoriesJSON({commit}, {response,menu}) {
      let menuObjWrapper = {};
      let catWrapper = [];
      var i = 0;
      var that = this;
      menuObjWrapper.menuID = menu.menuId;
      response.forEach(function(doc) {
        catWrapper.push(doc.data());
        catWrapper[i].catId = doc.id;
        i++;
      });
      menuObjWrapper.categories = catWrapper;
      commit('setCategories', {
        cat: menuObjWrapper,
        completeCat: false
      })

      that.dispatch('readItems', menuObjWrapper);
    },
    async readItems(context, currentCatObj) {
      var that = this;
      let currentCat;
      for (let y = 0; y < currentCatObj.categories.length; y++) {
        currentCat = currentCatObj.categories[y];
        await db.collection('menus').doc(currentCatObj.menuID).collection('categories').doc(currentCat.catId).collection('items')
          .orderBy("order", "asc").orderBy("title")
          .get()
          .then(function(querySnapshot) {
            that.dispatch('setItemsJSON', {
              response: querySnapshot,
              category: currentCat,
              inst: that
            });
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      }
    },
    setItemsJSON({state,commit}, {response,category}) {
      let catObjWrapper = {};
      let itemWrapper = [];
      var i = 0;
      catObjWrapper.catID = category.catId;
      response.forEach(function(doc) {
        itemWrapper.push(doc.data());
        itemWrapper[i].itemId = doc.id;
        i++;
      });
      catObjWrapper.items = itemWrapper;
      commit('setItems', {
        item: catObjWrapper,
        completeItem: false
      })

      let parsed = JSON.stringify(state.catItemsWrapper);
      localStorage.setItem('menuItems', parsed);
    },
    async commitLocalData({state,commit,dispatch}) {
      await dispatch("getUrlParam", { parameter:'restaurantId', defaultvalue: 'generalerror'});
      // if(state.restaurantInfo.restaurantId != state.restaurantUrlId) {
        dispatch('resetAll');
      // }
      var localObj = await dispatch('getLocalData');
      if (localStorage.getItem('restaurantInfo')) {
        commit('setRestaurant', localObj.localRestaurantInfo);
        commit('setMenu', localObj.localMenuList);
        commit('setLogoUrl', localObj.localLogoUrl);
      }
      if (localStorage.getItem('menuCat')) {
        commit('setCategories', {
          cat: localObj.localCat,
          completeCat: true
        });
        commit('setItems', {
          item: localObj.localItems,
          completeItem: true
        });
      }
      setTimeout(function(){
        commit("setLoader")
      }, 700);

    },
    resetAll({state, commit}) {
      commit('resetAllStates')
      localStorage.clear();
    },
    async getLocalData({state, dispatch}) {
      try {
          var localObj = {};
          if (localStorage.getItem('restaurantInfo')) {
            localObj.localRestaurantInfo = await JSON.parse(localStorage.getItem('restaurantInfo'));
            localObj.localLogoUrl = await localStorage.logoUrl;
            localObj.localMenuList = await JSON.parse(localStorage.getItem('menuList'));
          } else {
            dispatch("readRestaurant");
          }
          if (localStorage.getItem('menuCat')) {
            localObj.localCat = await JSON.parse(localStorage.getItem('menuCat'));
            localObj.localItems = await JSON.parse(localStorage.getItem('menuItems'));
          } else {
            dispatch('readCategories');
          }
      } catch (err) {
        console.log(err);
      }
      return localObj
    },
  },
  getters: {
    getCatById: (state) => (id) => {
    return state.menuCatWrapper.find(cat => cat.menuID === id)
  },
   getItemById: (state) => (id) => {
      return state.catItemsWrapper.find(items => items.catID === id);
   },
  },
  modules: {}
});
